import classNames from 'classnames'
import DotsLoading from 'components/loadings/dotsLoading'
import React from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { BankConvertor } from 'utilities/helper/banksConvertor'
interface IModalProps {
    show: boolean
    onHide: () => void
    data: Array<IBankAccountCards> | undefined | false
    activeAccounts: IBankAccountCards[] | undefined
    otherAccounts: IBankAccountCards[] | undefined
    selectedUser: string | undefined
    setSelectedBankNumber: React.Dispatch<React.SetStateAction<number>>
    handleSelectCard: (id: number) => void
}
export default function WithDrawWalletModal({
    show,
    onHide,
    data,
    activeAccounts,
    otherAccounts,
    selectedUser,
    setSelectedBankNumber,
    handleSelectCard,
}: IModalProps) {
    const navigate = useNavigate()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" py-3 px-2 text-sm">
                <p className=" text-center text-sm">
                    یک شماره حساب را به عنوان حساب اصلی صندوق انتخاب کنید:
                </p>
                <hr className=" my-2" />
                <button
                    type="button"
                    className="bg-green-main text-green-1  rounded-md py-2 my-2 w-full text-sm"
                    onClick={() => navigate('/manage-bank-cards/add')}
                >
                    ثبت شماره حساب جدید
                </button>
                {data ? (
                    <div className=" h-96 overflow-y-scroll">
                        <p> حساب های {selectedUser}</p>
                        {activeAccounts &&
                            activeAccounts.map((item) => (
                                <div
                                    className={classNames(
                                        ' flex justify-start rounded-lg py-2 px-3 items-center  my-2',
                                        item.isSelected
                                            ? 'bg-header-bg'
                                            : 'bg-gray-5'
                                    )}
                                    onClick={() => {
                                        setSelectedBankNumber(item.id)
                                        handleSelectCard(item.id)
                                    }}
                                    key={item.id}
                                >
                                    <img
                                        src={
                                            BankConvertor[item.bank_unique_code]
                                        }
                                        alt="bank"
                                        className=" w-10 h-10"
                                    />
                                    <div className=" mr-3">
                                        <p>{item.full_name}</p>
                                        <p className=" mt-2">
                                            {item.card_number
                                                ? item.card_number
                                                      .match(/.{1,4}/g)
                                                      ?.join(' ')
                                                : item.iban
                                                      .match(/.{1,4}/g)
                                                      ?.join(' ')}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        {otherAccounts && otherAccounts?.length > 0 && (
                            <>
                                <hr className=" my-2" />
                                <p className=" my-2">حساب های شما</p>
                                {otherAccounts &&
                                    otherAccounts.map((item) => (
                                        <div
                                            className={classNames(
                                                ' flex justify-start rounded-lg py-2 px-3 items-center  my-2',

                                                item.isSelected
                                                    ? 'bg-header-bg'
                                                    : 'bg-gray-5'
                                            )}
                                            onClick={() => {
                                                setSelectedBankNumber(item.id)
                                                handleSelectCard(item.id)
                                            }}
                                            key={item.id}
                                        >
                                            <img
                                                src={
                                                    BankConvertor[
                                                        item.bank_unique_code
                                                    ]
                                                }
                                                alt="bank"
                                                className=" w-10 h-10"
                                            />
                                            <div className=" mr-3">
                                                <p>{item.full_name}</p>
                                                <p className=" mt-2">
                                                    {item.card_number
                                                        ? item.card_number
                                                              .match(/.{1,4}/g)
                                                              ?.join(' ')
                                                        : item.iban
                                                              .match(/.{1,4}/g)
                                                              ?.join(' ')}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                            </>
                        )}
                    </div>
                ) : (
                    <DotsLoading />
                )}

                <div>
                    <hr className=" my-2" />
                    <p className=" text-green-1 text-center" onClick={onHide}>
                        تایید
                    </p>
                </div>
            </div>
        </Modal>
    )
}
